import {
  Box,
  IconButton,
  Typography,
  useTheme,
  CircularProgress,
} from "@mui/material";
import { tokens } from "../../theme";
import { mockTransactions } from "../../data/mockData";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
// import EmailIcon from "@mui/icons-material/Email";
// import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
// import PersonAddIcon from "@mui/icons-material/PersonAdd";
// import TrafficIcon from "@mui/icons-material/Traffic";
import Header from "../../components/Header";
import CustomLineChart from "../../components/CustomLineChart";
//import LineChart from "../../components/LineChart";
//import GeographyChart from "../../components/GeographyChart";
//import BarChart from "../../components/BarChart";
import StatBox from "../../components/StatBox";
import ProgressCircle from "../../components/ProgressCircle";
//import { PlumbingSharp } from "@mui/icons-material";
import IndiaPumpMap from "../../components/IndiaPumpMap";
import { useAuth } from "../../AuthContext";
import PumpPerformanceChart from "../../components/PumpPerformanceChart";
const Dashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { dashboardData,formatDate } = useAuth();
 
 // console.log("this is the dashbord data from dashboard page", dashboardData);
  const {
    alert_data,
    last_7_days_aggregates,
    pump_location_list,
    total_consumers,
    closed_tickets,
    total_pumps,
    total_pumps_available,
    total_pumps_running,
    total_tickets,
  } = dashboardData;

  const pendingTickets = total_tickets - closed_tickets;
  return (
    <Box m="20px">
      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header
          title="Remote Monitoring System"
          subtitle="Solar Water Pumping System"
        />

        {/* <Box>
          <Button
            sx={{
              backgroundColor: colors.blueAccent[700],
              color: colors.grey[100],
              fontSize: "14px",
              fontWeight: "bold",
              padding: "5px 10px",
            }}
          >
            <DownloadOutlinedIcon sx={{ mr: "20px",pt:'0' }} />
            Download Reports
          </Button>
        </Box> */}
      </Box>

      {/* GRID & CHARTS */}
      <Box
        display="grid"
        gridTemplateColumns="repeat(10, 1fr)"
        gridAutoRows="140px"
        rowGap="30px"
      >
        {/* ROW 1 */}
        <Box
          gridColumn="span 2"
          // backgroundColor={colors.primary[900]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={dashboardData.total_consumers||'0'}
            subtitle="Total Customers"
            image={`../../../assets/customer.png`}
            // icon={
            //   <PersonAddIcon
            //     sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
            //   />
            // }
          />
        </Box>
        <Box
          gridColumn="span 2"
          //backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={dashboardData.total_pumps||'0'}
            subtitle="Total Pumps"
            increase="+14%"
            image={`../../../assets/BlueSolarPump.png`}
            // icon={
            //   <PlumbingSharp
            //     sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
            //   />
            // }
          />
        </Box>
        <Box
          gridColumn="span 2"
          // backgroundColor={colors.primary[400]}

          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={`${dashboardData.total_pumps_available || '0'}`}
            subtitle="Pumps Online"
            progress={
              dashboardData.total_pumps
                ? (dashboardData.total_pumps_available / dashboardData.total_pumps) * 100
                : 0
            }
            image={`../../../assets/GreenSolarPump.png`}
            total={dashboardData.total_pumps}
          />
        </Box>
         <Box
          gridColumn="span 2"
          // backgroundColor={colors.primary[400]}

          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={`${((dashboardData.total_pumps || 0) - (dashboardData.total_pumps_available || 0)) || '0'}`}
            subtitle="Pumps Offline"
            progress={
              dashboardData.total_pumps
                ? (dashboardData.total_pumps_available / dashboardData.total_pumps) * 100
                : 0
            }
            image={`../../../assets/RedSolarPump.png`}
            total={dashboardData.total_pumps}
          />
        </Box>

        <Box
          gridColumn="span 2"
          // backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={`${dashboardData?.total_pumps_running||'0'}`}
            subtitle=" Pumps Running"
            // progress={(dashboardData.total_pumps_running / dashboardData.total_pumps) * 100}
            image={`../../../assets/RedSolarPump.png`}
            total={dashboardData.total_pumps}
          />
        </Box>
        {/* <Box
          gridColumn="span 3"
          //backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title="2200"
            subtitle="Energy Generated"
            progress="0.75"
            increase="+14%"
            icon={
              <PlumbingSharp
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box> */}
        {/* ROW 2 */}
        <Box
          gridColumn="span 10"
          gridRow="span 3"
          backgroundColor={colors.primary[400]}
         // margin={'20px'}
        >
          <Box height="450px" m="10px 0 0 10px">
            <PumpPerformanceChart />
          </Box>
        </Box>

        <Box
          gridColumn="span 3"
          gridRow="span 2"
          backgroundColor={colors.primary[400]}
          overflow="auto"
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            borderBottom={`4px solid ${colors.primary[500]}`}
            p="15px"
          >
            <Typography color={colors.grey[100]} variant="h5" fontWeight="600">
              Recent Alerts
            </Typography>
          </Box>
          {alert_data?.map((alert, i) => (
            <Box
              key={i}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              borderBottom={`4px solid ${colors.primary[500]}`}
              p="15px"
            >
              <Box>
                <Typography
                  color={colors.greenAccent[500]}
                  variant="h5"
                  fontWeight="600"
                >
                  Alert Code: {alert.alert_code}
                </Typography>
                <Typography color={colors.grey[100]}>
                  IMEI: {alert.imei}
                </Typography>
              </Box>
              <Box color={colors.grey[100]}>
                 {formatDate(alert.time)}
                
              </Box>
              <Box
                backgroundColor={
                  alert.alert_level === "high"
                    ? colors.redAccent[500]
                    : 'green'
                }
                p="5px 10px"
                borderRadius="4px"
              >
                <Typography style={{color:'white'}}>
                  {alert.alert_level}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>

        {/* ROW 3 */}
        <Box
          gridColumn="span 3"
          gridRow="span 2"
          backgroundColor={colors.primary[400]}
          p="15px"
          marginX={'20px'}
        >
          <Typography variant="h5" fontWeight="600">
            Ticket Resolution
          </Typography>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            mt="20px"
          >
            <Box position="relative" display="inline-flex">
              <CircularProgress
                variant="determinate"
                value={(closed_tickets / total_tickets) * 100}
                size={150}
                thickness={7} // Increased thickness for better visibility
                sx={{
                  color: colors.greenAccent[500],
                }}
              />
              <CircularProgress
                variant="determinate"
                value={100} // Background circle
                size={150}
                thickness={1}
                sx={{
                  color: colors.grey[700], // Changed color for better contrast
                  position: "absolute",
                  top: 0,
                  left: 0,
                }}
              />
              <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Typography
                  variant="h4"
                  component="div"
                  color={colors.grey[100]}
                >
                  {closed_tickets}/{total_tickets}
                </Typography>
              </Box>
            </Box>
            <Typography sx={{ mt: "10px" }}>
              Pending Tickets: {pendingTickets}
            </Typography>
            <Typography variant="h5" color={colors.greenAccent[500]}>
              {closed_tickets} Tickets resolved out of total {total_tickets}
            </Typography>
          </Box>
        </Box>
        {/* <Box
          gridColumn="span 4"
          gridRow="span 2"
          backgroundColor={colors.primary[400]}
        >
          <Typography
            variant="h5"
            fontWeight="600"
            sx={{ padding: "30px 30px 0 30px" }}
          >
            Sales Quantity
          </Typography>
          <Box height="250px" mt="-20px">
            <BarChart isDashboard={true} />
          </Box>
        </Box> */}
        <Box
          gridColumn="span 4"
          gridRow="span 2"
          backgroundColor={colors.primary[400]}
          padding="5px"
        >
          <Typography
            variant="h5"
            fontWeight="600"
            sx={{ marginBottom: "5px" }}
          >
            Pump Locations
          </Typography>
          <Box height="90%">
            <IndiaPumpMap  />
            {/* <GeographyChart isDashboard={true} /> */}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
